import * as React from 'react'
import MUISnackbar from '@mui/material/Snackbar'

const Snackbar = (props) => <MUISnackbar {...props} />

export default Snackbar
